import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for content impression event. The impression starts when a content is visible to the viewer, and impression ends when the content is not visible to the viewer.
const LINGER_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'linger',
  format: 'jsonschema',
  version: '1-0-0',
}

export type LingerContextSchemaData = {
  first_impression: boolean // Boolean indicating if this content is seen by the viewer for the first time
  visibility_start: string // Unix Timestamp at which the impression starts in millisecond
  visibility_end: string // Unix Timestamp at which the impression ends in millisecond
}

export const lingerContextSchema = (
  data: LingerContextSchemaData
): ContextSchema<LingerContextSchemaData> => ({
  schema: schemaPath(LINGER_SCHEMA),
  data,
})
